export enum ArticlesEndpointsEnum {
  ARTICLES = "/articles",
}
